import React, { FC } from 'react';
import classnames from 'classnames';

import { InfoBlockSubtitle } from '@/shared/components/InfoBlockSubtitle/InfoBlockSubtitle';

import { useQuestions } from './hooks/useQuestions';
import { HomeFaqItem } from './_HomeFaqItem';
import { useI18n } from './hooks/useFaqI18n';
import type { HomeFaqItems, HomeFaqItemType } from './types';
import styles from './HomeFaq.module.css';

interface HomeFaqProps {
    className?: string;
    specialQuestions?: HomeFaqItems;
    hiddenQuestions?: number[];
}

export const HomeFaq: FC<HomeFaqProps> = ({
    className,
    specialQuestions = [],
    hiddenQuestions = [],
}) => {
    const i18n = useI18n();

    const { activeQuestionIndex, handleQuestionOpen, questions } = useQuestions(
        specialQuestions,
        hiddenQuestions
    );

    const filteredQuestions: HomeFaqItems = questions.filter(
        (question): question is HomeFaqItemType => question !== undefined
    );

    return (
        <div className={classnames(styles.root, className)}>
            <InfoBlockSubtitle className={styles.title}>{i18n('faq__title')}</InfoBlockSubtitle>
            {filteredQuestions.map((question, index) => (
                <HomeFaqItem
                    key={question.title}
                    index={index}
                    question={question}
                    active={index === activeQuestionIndex}
                    onOpen={handleQuestionOpen}
                />
            ))}
        </div>
    );
};
